import { Image } from "antd";
import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

function SignUp(props) {
  const navigate = useNavigate();
  const [mobilefield, setMobilefield] = useState("");
  let errorsObj = { email: "", password: "" };
  let mobilefieldErrorObj = { mobilefield: "" };
  const [otpErrors, setOtpErrors] = useState(mobilefieldErrorObj);
  const [isMobileLoading, setMobileLoading] = useState(false);

  function onOTPSignUp(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...mobilefieldErrorObj };

    if (mobilefield === "") {
      errorObj.mobilefield = "Field is Required";
      error = true;
    } else {
      setMobileLoading(true);
    }
    setOtpErrors(errorObj);
    if (error) {
      return;
    }
    let payload = {
      mobile_number: mobilefield,
    };

    console.log({ payload });

    props.apis
      .apiConnectorSignUpRequest(payload)
      .then((res) => {
        console.log({ apiConnectorSignUpRequest: res });
        props.store("connectorSignUpMobileNumber", mobilefield);
        navigate("/open/connector/signupverify");
        setMobileLoading(false);
      })
      .catch((err) => {
        console.log({ OTPlogin: err });
        const errorObj = { ...errorsObj };
        errorObj.mobilefield = "Mobile number login failed";
        setOtpErrors(errorObj);
        setMobileLoading(false);
      });
  }

  props.$setNode({
    props,
  });

  return (
    <div className="page-wraper">
      <div className="browse-job login-style3">
        <div className="bg-img-fix overflow-hidden">
          <div className="parent-container row gx-0">
            <div
              className="col-xl-6 col-lg-6 col-md-6 col-sm-12 login_img_bg"
              style={{ backgroundImage: "url(" + imagepaths.loginBg + ")" }}
            >
              <div className="logo_header ps-3">
                <Link to={"/open/connector/login"} className="logo">
                  <img src={imagepaths.logoWithTagline} alt="" />
                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
              <div className="login-form style-2 py-4">
                <div className="card-body">
                  <div className="nav nav-tabs border-bottom-0">
                    <div className="tab-content w-100" id="nav-tabContent">
                      <div
                        className="tab-pane fade active show"
                        id="nav-personal"
                      >
                        {props.errorMessage && (
                          <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                            {props.errorMessage}
                          </div>
                        )}
                        {props.successMessage && (
                          <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                            {props.successMessage}
                          </div>
                        )}

                        <div className="w-100 text-center">
                          <Image
                            src={imagepaths.logoHome}
                            preview={false}
                            width={150}
                            className="mb-4 pointer-cursor"
                            alt="logo"
                            onClick={() => navigate("/open/connector/login")}
                          />
                        </div>
                        <h3 className="form-title m-t0 text-center">
                          Welcome to Wealth Avenue
                        </h3>
                        <div className="dz-separator-outer m-b5">
                          <div className="dz-separator bg-primary style-liner"></div>
                        </div>
                        <p className="sub-title text-center">
                          Access to explore more
                        </p>
                        <form
                          className=" dz-form pb-3 mt-5"
                          onSubmit={onOTPSignUp}
                        >
                          <div className="form-group mb-3">
                            <label>Mobile no.</label>
                            <input
                              value={mobilefield}
                              type="number"
                              className="form-control"
                              onChange={(e) => setMobilefield(e.target.value)}
                              placeholder="Please enter"
                            />
                            {otpErrors.mobilefield && (
                              <div className="text-danger fs-12">
                                {otpErrors.mobilefield}
                              </div>
                            )}
                          </div>
                          <div
                            className={Object.className({
                              "form-group text-left": true,
                              "not-allowed": isMobileLoading,
                            })}
                          >
                            <button
                              type="submit"
                              className="btn btn-primary button-md btn-block"
                              disabled={isMobileLoading}
                            >
                              {isMobileLoading ? "Loading…" : "Send OTP"}
                            </button>
                          </div>
                        </form>
                        <div className="text-center bottom">
                          <span>Already Registered? Click here to </span>
                          <NavLink
                            to="/open/connector/login"
                            className="text-primary fw-bold"
                          >
                            Login
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default constore(SignUp);
